export const PLAYER_POSITIONS = [
    {
        "id": 24,
        "parent_id": "",
        "name": "Goalkeeper",
        "code": "goalkeeper",
        "developer_name": "GOALKEEPER"
    },
    {
        "id": 25,
        "parent_id": "",
        "name": "Defender",
        "code": "defender",
        "developer_name": "DEFENDER"
    },
    {
        "id": 26,
        "parent_id": "",
        "name": "Midfielder",
        "code": "midfielder",
        "developer_name": "MIDFIELDER"
    },
    {
        "id": 27,
        "parent_id": "",
        "name": "Attacker",
        "code": "attacker",
        "developer_name": "ATTACKER"
    },
    {
        "id": 28,
        "parent_id": "",
        "name": "Unknown",
        "code": "unknown",
        "developer_name": "UNKNOWN"
    },
    {
        "id": 148,
        "parent_id": 25,
        "name": "Centre Back",
        "code": "centre-back",
        "developer_name": "CENTRE_BACK"
    },
    {
        "id": 149,
        "parent_id": 26,
        "name": "Defensive Midfield",
        "code": "defensive-midfied",
        "developer_name": "DEFENSIVE_MIDFIELD"
    },
    {
        "id": 150,
        "parent_id": 26,
        "name": "Attacking Midfield",
        "code": "attacking-midfied",
        "developer_name": "ATTACKING_MIDFIELD"
    },
    {
        "id": 151,
        "parent_id": 27,
        "name": "Centre Forward",
        "code": "centre-forward",
        "developer_name": "CENTRE_FORWARD"
    },
    {
        "id": 152,
        "parent_id": 27,
        "name": "Left Wing",
        "code": "left-wing",
        "developer_name": "LEFT_WING"
    },
    {
        "id": 153,
        "parent_id": 26,
        "name": "Central Midfield",
        "code": "central-midfied",
        "developer_name": "CENTRAL_MIDFIELD"
    },
    {
        "id": 154,
        "parent_id": 25,
        "name": "Right Back",
        "code": "right-back",
        "developer_name": "RIGHT_BACK"
    },
    {
        "id": 155,
        "parent_id": 25,
        "name": "Left Back",
        "code": "left-back",
        "developer_name": "LEFT_BACK"
    },
    {
        "id": 156,
        "parent_id": 27,
        "name": "Right Wing",
        "code": "right-wing",
        "developer_name": "RIGHT_WING"
    },
    {
        "id": 157,
        "parent_id": 26,
        "name": "Left Midfield",
        "code": "left-midfield",
        "developer_name": "LEFT_MIDFIELD"
    },
    {
        "id": 158,
        "parent_id": 26,
        "name": "Right Midfield",
        "code": "right-midfield",
        "developer_name": "RIGHT_MIDFIELD"
    },
    {
        "id": 163,
        "parent_id": 27,
        "name": "Secondary Striker",
        "code": "secondary_striker",
        "developer_name": "SECONDARY_STRIKER"
    },
    {
        "id": 221,
        "parent_id": "",
        "name": "Coach",
        "code": "coach",
        "developer_name": "COACH"
    },
    {
        "id": 226,
        "parent_id": "",
        "name": "Assistant Coach",
        "code": "assistant-coach",
        "developer_name": "ASSISTANT_COACH"
    },
    {
        "id": 227,
        "parent_id": "",
        "name": "Goalkeeping Coach",
        "code": "goalkeeping-coach",
        "developer_name": "GOALKEEPING_COACH"
    },
    {
        "id": 228,
        "parent_id": "",
        "name": "Forward Coach",
        "code": "forward-coach",
        "developer_name": "FORWARD_COACH"
    },
    {
        "id": 560,
        "parent_id": "",
        "name": "Caretaker Manager",
        "code": "caretaker-manager",
        "developer_name": "CARETAKER_MANAGER"
    }
]